import { getAuthCookies } from "../services/auth-cookies/auth-cookies.service";
import { parseJwt } from "../services/jwt/jwt.service";
import type { TJwtPayload } from "../services/jwt/jwt.types";

export const jwtToken = (): string | null => {
  const cookies = getAuthCookies();
  return cookies.idToken;
};

export const getTokenConfig = (): {
  headers: { Authorization: string | null };
} => {
  return {
    headers: {
      Authorization: jwtToken(),
    },
  };
};

export const getJwtTokenConfig = (): {
  headers: { authorization: string | null };
} => {
  return {
    headers: {
      authorization: jwtToken(),
    },
  };
};

export const decodeJWT = (
  token: string,
): TJwtPayload | Record<string, unknown> => {
  const payload = parseJwt(token);
  if (!payload) {
    throw new Error("Invalid token");
  }
  return payload;
};

export const getToken = (name: string): string | undefined => {
  if (globalThis.document === undefined) return undefined;

  const value = globalThis.document.cookie.split(`${name}=`);
  if (value.length === 2) {
    return value.pop()?.split(";").shift();
  }

  return undefined;
};

export const getSocialLoginToken = (name: string): string | undefined => {
  if (globalThis.localStorage === undefined) return undefined;

  const key = Object.keys(globalThis.localStorage).find((k) =>
    k.includes(name),
  );

  if (key && name === "userData") {
    const stored = globalThis.localStorage.getItem(key);
    if (!stored) return undefined;
    return (JSON.parse(stored) as { Username: string }).Username;
  }

  if (key) return globalThis.localStorage.getItem(key) ?? undefined;

  return undefined;
};

export const userHasPhoneNumber = (name: string): boolean => {
  if (globalThis.localStorage === undefined) return false;

  const key = Object.keys(globalThis.localStorage).find((k) =>
    k.includes(name),
  );

  if (key && name === "userData") {
    const stored = globalThis.localStorage.getItem(key);
    if (!stored) return false;
    const userData = (
      JSON.parse(stored) as { UserAttributes: Array<{ Name: string }> }
    ).UserAttributes;
    return userData.some((attr) => attr.Name === "phone_number");
  }

  return false;
};
